/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import parse, { domToReact } from "html-react-parser";
import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";
import { shuffle, slice } from "lodash";
import {
  Wrapper,
  Item,
  Box,
  BoxesWrapper,
  BubbleOverlay,
  BubbleText
} from "./styled";
import { TEXTS_AT_LEVEL } from "../constants";
import ScoreOverlay from "../ScoreOverlay";
import data from "../pairs";
import images from "../images";

const regex = /\{\{\{(.*?)\}\}\}/g;
const regex2 = /\{\{\{(.*?)\}\}\}/;

const getLevelData = l =>
  slice(shuffle(data.filter(d => d.level === l)), 0, TEXTS_AT_LEVEL);

const bubblesTexts = shuffle([
  "Не ищи ничего. Всё равно это никому не нужно",
  "Я просто забыл поставить ссылку",
  "Ещё не поздно остановиться",
  "Этот фрагмент вообще не важен",
  "Ладно, это уже не смешно. Прекращай!",
  "Я уважаемый человек! Ты хочешь разрушить мою карьеру?",
  "В чьих интересах ты проверяешь эту диссертацию?",
  "Ты не понимаешь с кем связался!",
  "Это заказ конкурентов!",
  "Ты разрушаешь российскую науку!",
  "Тебя наняли меня перед выборами опорочить",
  "Да я первую монографию еще в школе написал!",
  "Это не я списал, а у меня!",
  "Может, договоримся?",
  "Я живу на Крайнем Севере, там библиотеки нет",
  "Старайся-старайся. У меня всё схвачено"
]);

const bubbles = shuffle([
  {
    image: images.bouble_1.src,
    imageD: images.bouble_1_d.src,
    pos: "bottom left",
    width: 248,
    widthD: 1004
  },
  {
    image: images.bouble_2.src,
    imageD: images.bouble_2_d.src,
    pos: "bottom right",
    width: 263,
    widthD: 1048
  },
  {
    image: images.bouble_3.src,
    imageD: images.bouble_3_d.src,
    pos: "top left",
    width: 250,
    widthD: 1004
  },
  {
    image: images.bouble_4.src,
    imageD: images.bouble_4_d.src,
    pos: "top right",
    width: 263,
    widthD: 1048
  }
]);

function Game({ onNext, onIncrement, onStart, onSetSad }) {
  const [html1, setHtml1] = useState(null);
  const [html2, setHtml2] = useState(null);
  const [ids, setIds] = useState([]);
  const [level, setLevel] = useState(1);
  const [levelTexts, setLevelTexts] = useState(getLevelData(level));
  const [textIndex, setTextIndex] = useState(0);
  const [currentData, setCurrentData] = useState(null);
  const [scoreOverlay, setScoreOverlay] = useState(false);
  const [bubbleIndex, setBubbleIndex] = useState(0);
  const [bubbleTextIndex, setBubbleTextIndex] = useState(0);
  const [showBubble, setShowBubble] = useState(false);
  const intervalRef = useRef();

  const bubble = bubbles[bubbleIndex];
  const bubbleText = bubblesTexts[bubbleTextIndex];

  const func = index => {
    setShowBubble(true);
    intervalRef.current = setTimeout(() => {
      setShowBubble(false);
      intervalRef.current = setTimeout(() => {
        setBubbleIndex(prev => prev + 1);
        setBubbleTextIndex(prev => prev + 1);
        func();
      }, 20000);
    }, 1500);
  };

  useEffect(() => {
    if (bubbleIndex >= bubbles.length) {
      setBubbleIndex(0);
    }

    if (bubbleTextIndex >= bubblesTexts.length) {
      setBubbleTextIndex(0);
    }
  }, [bubbleIndex, bubbleTextIndex]);

  useEffect(() => {
    setCurrentData(levelTexts[textIndex]);
    onStart();

    intervalRef.current = setTimeout(() => {
      func();
    }, 20000);

    return () => clearTimeout(intervalRef.current);
  }, []);

  useEffect(() => {
    if (currentData) {
      const texts = currentData.first
        .match(regex)
        .reduce(
          (acc, cur, id) =>
            acc.map(t => t.replace(regex2, `<span data-id="${id}">$1</span>`)),
          [currentData.first, currentData.second]
        );

      setHtml1(texts[0]);
      setHtml2(texts[1]);
    }
  }, [textIndex, levelTexts, currentData]);

  useEffect(() => {
    if (currentData) {
      if (ids.length === currentData.first.match(regex).length) {
        setScoreOverlay(true);
        onIncrement();
        onSetSad(false);
        setTimeout(() => {
          setScoreOverlay(false);
          setTextIndex(textIndex + 1);
          setIds([]);
        }, 1000);
      }
    }
  }, [ids]);

  useEffect(() => {
    if (textIndex === levelTexts.length) {
      setLevel(level + 1);
      setTextIndex(0);
    }
  }, [textIndex]);

  useEffect(() => {
    if (level > 3) {
      onNext();
    }
    setLevelTexts(getLevelData(level));
  }, [level]);

  useEffect(() => {
    setCurrentData(levelTexts[textIndex]);
  }, [levelTexts, textIndex]);

  const options = {
    replace: ({ attribs, children }) => {
      if (!attribs) return;
      return (
        <Item
          {...attribs}
          onClick={handleClick}
          clicked={ids.indexOf(attribs["data-id"]) > -1}
        >
          {domToReact(children, options)}
        </Item>
      );
    }
  };

  const handleClick = e => {
    const id = e.target.getAttribute("data-id");

    if (ids.indexOf(id) < 0) {
      setIds([...ids, id]);
    }
  };

  return (
    <Wrapper>
      <ScrollSync>
        <BoxesWrapper>
          {html1 && (
            <ScrollSyncPane>
              <Box color="#FF000D">{parse(html1, options)}</Box>
            </ScrollSyncPane>
          )}
          {html2 && (
            <ScrollSyncPane>
              <Box color="#0000FF">{parse(html2, options)}</Box>
            </ScrollSyncPane>
          )}
        </BoxesWrapper>
      </ScrollSync>
      {scoreOverlay && <ScoreOverlay score={1} />}
      {showBubble && (
        <BubbleOverlay b={bubble}>
          <BubbleText b={bubble}>{bubbleText}</BubbleText>
        </BubbleOverlay>
      )}
    </Wrapper>
  );
}

export default Game;
